import { useEffect } from 'react'
import useSWR from 'swr'

import fetcher from '../../lib/fetcher'
import { makeStrapiImageUrl } from '../../util/url'

export interface Campaign {
  id: number
  name: string
  referrer: {
    heading: string
    description: string
    image: { url: string }
    link: {
      text: string
      image: { url: string }
    }
  }
  referee: {
    heading: string
    description: string
    image: { url: string }
  }
}

function transform(campaign: Campaign) {
  return {
    ...campaign,
    referrer: {
      ...campaign.referrer,
      image: {
        ...campaign.referrer.image,
        url: makeStrapiImageUrl(campaign.referrer.image.url),
      },
      link: {
        ...campaign.referrer.link,
        image: {
          ...campaign.referrer.link.image,
          url: makeStrapiImageUrl(campaign.referrer.link.image.url),
        },
      },
    },
    referee: {
      ...campaign.referee,
      image: {
        ...campaign.referee.image,
        url: makeStrapiImageUrl(campaign.referee.image.url),
      },
    },
  }
}

export function useCampaign() {
  const { data, error } = useSWR<Campaign[]>('/campaigns?active=true', fetcher.api)

  useEffect(() => {
    if (error) {
      console.error('🔴 Error getting active referral campaign', { error, data })
    }
  }, [error, data])

  return {
    campaign: data?.[0] && transform(data[0]),
    isLoading: !error && !data,
    error: error || !data?.[0],
  }
}
